export default __webpack_public_path__ + "static/media/mlflowlogo.daf06037.png";